jQuery(function($) {
    //counter
    //https://stackoverflow.com/questions/68605784/animated-counter-when-scrolling-into-viewport-with-thousands-separator
    const animNum = (EL) => {
        if (EL._isAnimated) return; // Animate only once!
        EL._isAnimated = true;

        $(EL).prop('Counter', 0).animate({
            Counter: EL.dataset.counter
        }, {
            duration: 5000,
            step: function(now) {
                const text = (Math.ceil(now)).toLocaleString('en-US');
                const html = text.split(".").map(n => `<span class=" add_class count">${n}</span>`).join(".");
                $(this).html(html);
            }
        });
    };

    const inViewport = (entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) animNum(entry.target);
        });
    };

    $("[data-counter]").each((i, EL) => {
        const observer = new IntersectionObserver(inViewport);
        observer.observe(EL);
    });
});
